import { SxProps, Theme } from '@mui/material';

type NoArg = SxProps<Theme>;

interface CreateCardInterface {
	container: NoArg;
	containerIconLabel: NoArg;
	iconContainer: NoArg;
	label: NoArg;
	formContainer: NoArg;
	title: NoArg;
	field: NoArg;
	saveButton: NoArg;
	containerCancelButton: NoArg;
	cancelButton: NoArg;
}

export const createCardSX: CreateCardInterface = {
	container: {
		display: 'flex',
		justifyContent: { xs: 'start', lg: 'center' },
		alignItems: 'center',
		borderRadius: '0',
		minHeight: { lg: '202px' },
		height: '100%',
		p: '10px',
		cursor: 'pointer',
	},
	containerIconLabel: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: { xs: 'row', lg: 'column' },
		my: '10px',
		pr: { lg: '0' },
	},
	iconContainer: {
		display: 'flex',
		width: { xs: '40px', md: '60px' },
		height: { xs: '40px', md: '60px' },
		borderRadius: '50%',
		backgroundColor: 'grey.50',
		alignItems: 'center',
		justifyContent: 'center',
		color: 'primary.main',
	},
	label: {
		mt: { xs: '0', lg: '20px' },
		ml: { xs: '10px', lg: '0' },
		color: 'productTagColor.tag_pdp-ex',
	},
	formContainer: {
		display: 'flex',
		justifyContent: 'start',
		alignItems: 'start',
		flexDirection: 'column',
		width: '100%',
	},
	title: {
		mb: '10px',
		color: 'grey.500',
	},
	field: {
		my: '10px',
		//Input base
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: 'primary.light',
		},
		'& .MuiOutlinedInput-root': {
			color: 'grey.500',
			'&:hover .MuiOutlinedInput-notchedOutline': {
				borderColor: 'primary.light',
			},
			'&.Mui-error .MuiOutlinedInput-notchedOutline': {
				borderColor: 'grey.200',
				borderBottom: '2px solid',
				borderBottomColor: 'error.main',
			},
			'&.Mui-error:hover .MuiOutlinedInput-notchedOutline': {
				borderColor: 'primary.light',
			},
		},

		//Label base
		'& .MuiInputLabel-root': {
			color: 'grey.200',
			'&.Mui-error': {
				color: 'grey.200',
				'&:hover + .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
					borderColor: 'primary.light',
				},
			},
		},

		//Helper text on error
		'& .MuiFormHelperText-root.Mui-error': {
			ml: 0,
		},
	},
	saveButton: {
		height: '42px',
		mb: '10px',
		'&:hover': {
			backgroundColor: 'primary.main',
			borderColor: 'primary.main',
			color: 'white',
		},
	},
	containerCancelButton: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
	},
	cancelButton: {
		color: 'secondary.main',
		'&:hover': {
			textDecoration: 'underline',
			cursor: 'pointer',
		},
	},
};
